<template>
    <div class="preview-img-list" @click="closePreview">
        <div class="imglist-header"><span class="imglist-back" @click="closePreview">×</span><h4></h4></div>
        <swipe class="swipe"
                :auto="0"
                :showIndicators="false"
                :start-page="startPage || 0"
                v-on:afterSlide="afterSlide"
                ref="swiper">
            <swipe-item class="swipe-item" v-for="item in photos" :key="item">
                <img :src="item">
            </swipe-item>
        </swipe>
        <div class="imglist-footer">
            <span class="imglist-title"></span>
            <span class="imglist-page"><b>{{page}}</b>/{{photos && photos.length}}</span>
        </div>
    </div>
</template>

<script>
import {
    Swipe,
    SwipeItem
} from '@/components/detail/swipe/index';

export default {
    name: 'previewer',
    data: function() {
        return {
            page: 1
        }
    },
    props: ['photos', 'startPage'],
    methods: {
        closePreview() {
            this.$emit('closePreview');
        },
        afterSlide(index) {
            this.page = index + 1;
        }
    },
    components: {
        'swipe': Swipe,
        'swipe-item': SwipeItem
    }
}
</script>

<style lang="scss">
.preview-img-list {
    display: block;
    position: fixed;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #222;
    color: #fff;
    z-index: 101;
    touch-action: manipulation;
    .imglist-header {
        position: absolute;
        width: 100%;
        height: 50px;
        z-index: 10;
        .imglist-back {
            font-family: initial;
            font-size: 25px;
            display: inline-block;
            padding: 11px 15px;
            touch-action: manipulation;
        }
        h4 {
            display: inline-block;
            position: absolute;
            left: 50px;
            right: 50px;
            font-size: 16px;
            height: 50px;
            line-height: 50px;
            text-align: center;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
        }
        .imglist-share {
            display: inline-block;
            position: absolute;
            right: 0;
            font-size: 20px;
            padding: 15px;
        }
    }
    .imglist-container {
        height: 100%;
        img {
            width: 100%;
            position: absolute;
            top: 50%;
            -webkit-transform: translateY(-50%);
            transform: translateY(-50%);
        }
        ul {
            height: 100%;
            li {
                position: relative;
                float: left;
                height: 100%;
                margin-top: -50px;
            }
        }
    }
    .imglist-footer {
        position: absolute;
        width: 100%;
        bottom: 0;
        font-size: 16px;
        margin: 0 auto;
        height: 50px;
        line-height: 50px;
        text-align: center;
        padding: 0 15px;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        .imglist-title {
            float: left;
        }
        .imglist-page {
            float: right;
            b {
                font-weight: normal;
            }
        }
    }
    .swipe {
        overflow: hidden;
        position: relative;
        height: 100%;
    }
    .mint-swipe-items-wrap {
        position: relative;
        overflow: hidden;
        height: 100%;
        -webkit-transform: translateZ(0);
        transform: translateZ(0)
    }
    .mint-swipe-items-wrap > div {
        position: absolute;
        -webkit-transform: translateX(-100%);
        transform: translateX(-100%);
        width: 100%;
        height: 100%;
        display: none;
        img {
            position: absolute;
            width: 100%;
            top: 50%;
            -webkit-transform: translateY(-50%);
            transform: translateY(-50%);
        }
    }
    .mint-swipe-items-wrap > div.is-active {
        display: block;
        -webkit-transform: none;
        transform: none;
    }
    .mint-swipe-indicators {
        position: absolute;
        bottom: 12px;
        text-align: center;
        width: 100%;
        .mint-swipe-indicator {
            width: 15px;
            height: 2px;
            margin: 0 1px;
            background: rgba(160, 160, 160, 0.5);
            overflow: hidden;
            cursor: pointer;
            display: inline-block;
            &.is-active {
                background: #23cc77;
            }
            &:only-child {
                display: none;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// Previewer.vue